import { FC, memo, ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export const PageTitle: FC<Props> = memo((props) => {
  const { children } = props;
  return <h2 className="text-gray-800 text-2xl lg:text-3xl font-bold text-center mb-4 md:mb-8">{children}</h2>;
});
